<template>
  <v-row class="question-side-panel" no-gutters>
    <v-col class="d-flex" cols="12">
      <v-icon v-if="question.group">mdi mdi-subdirectory-arrow-right</v-icon>
      <v-btn class="question-btn px-0 py-4" small text @click="scrollToQuestion">
        <div class="question-btn__content">
          <v-icon v-if="question.type === 'GROUP'">mdi mdi-layers-triple-outline</v-icon>
          <v-icon v-if="question.type === 'SLIDER'">mdi mdi-speedometer</v-icon>
          <v-icon v-if="question.type === 'CHOICE_SINGLE'">mdi mdi-format-list-checks</v-icon>
          {{ title }}
        </div>

      </v-btn>
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: "QuestionSidePanel",
  data() {
    return {
      /*question: {
        titleTid: null,
        contentTid: null,
        type: null,
        order: null,
        groupKey: null,
        sliderMin: null,
        sliderMax: null,
        sliderStep: null,
        sliderMinTid: null,
        sliderMaxTid: null,
        choiceLimit: null,
        choiceList: [],
        tempKey: null,
      },*/
    }
  },
  computed: {
    title() {
      return this.question[this.$tidTextField('titleTid')] || (this.question.type ? this.$t(`questions.types.${this.question.type}`) : this.$t('select'));
    }
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  methods: {
    scrollToQuestion() {
      const el = document.querySelector(`.question-card[data-question-key='${this.question.key || this.question.tempKey}']`);
      if (el) {
        const yOffset = -70;
        const y = el.getBoundingClientRect().top + yOffset;
        window.scrollTo({top: y, behavior: "smooth"})
      }

    }
  }
}
</script>

<style lang="scss">
.question-side-panel {
  .question-btn {
    max-width: 100%;
    min-width: 0;
    width: 100%;
    flex: 1;

    .v-btn__content {
      flex: 1;
      min-width: 0;
      justify-content: flex-start;
    }

    .question-btn__content {
      white-space: nowrap;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>

